import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Progress = React.forwardRef(({ className = '', value = 0, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: `relative h-4 w-full overflow-hidden rounded-full bg-gray-200 ${className}`, ...props, children: _jsx("div", { className: "h-full bg-blue-600 transition-all duration-300", style: { width: `${Math.min(100, Math.max(0, value))}%` } }) }));
});
Progress.displayName = 'Progress';
